import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type Props = {
  displayText?: string
  toolTip?: string
  className?: string
}

export const AncientFormWrapVertical: React.FC<Props> = ({
  displayText,
  toolTip,
  children,
  className,
}) => {
  return (
    <>
      {displayText != undefined && displayText != '' ? (
        <div className={`mb-5 ${className}`}>
          {displayText != undefined && displayText != '' ? (
            <OverlayTrigger
              placement='top'
              delay={{show: 250, hide: 400}}
              overlay={toolTip ? <Tooltip>{toolTip}</Tooltip> : <></>}
            >
              <label className='form-label'>{displayText}</label>
            </OverlayTrigger>
          ) : null}
          {children}
        </div>
      ) : (
        children
      )}
    </>
  )
}
